/**
 * KPI status vocabulary — the single source of truth for KPI / severity tone
 * across the platform. The design system re-exports `KpiStatus` from here
 * (`packages/ui/src/lib/types.ts`) and `@playbookai/widget-schemas` derives
 * `z.enum(KPI_STATUSES)` from the same array, mirroring how `WIDGET_KINDS`
 * feeds the widget params registry. Status is the *semantic* value — the
 * status → colour/tone mapping is a presentation concern owned by the DS,
 * never stored on the wire.
 */
export const KPI_STATUSES = ["healthy", "watch", "critical", "none"];
//# sourceMappingURL=kpi.js.map